import React, { useState, useEffect, useRef } from "react"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { removeFailedPrints } from "@redux"
import { createPrintRequest, ObjectValues } from "utils"
import classes from "./FailedPrintFooter.module.scss"
import clsx from "clsx"

const FailedPrintFooter = props => {
  const {
    selectedFailedPrinter,
    selectedFailedPrints,
    setSelectedFailedPrints
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handlePrintSelectedPrints = async () => {
    setLoading(true)

    let somePrintsHaveFailed = false

    const removedFailedPrintRequestIds = []

    const failedPrints = ObjectValues(selectedFailedPrints)

    for (const failedPrint of failedPrints) {
      const request = {
        ...failedPrint,
        printerSettings: selectedFailedPrinter,
        saveToFailedPrints: false
      }

      try {
        await createPrintRequest(request)

        if (unmount.current) return

        removedFailedPrintRequestIds.push(
          failedPrint.printRequestId
        )

        setSelectedFailedPrints(prev => {
          const object = { ...prev }

          delete object[failedPrint.printRequestId]

          return object
        })
      } catch (err) {
        console.log(err)

        somePrintsHaveFailed = true
      }
    }

    dispatch(
      removeFailedPrints(
        removedFailedPrintRequestIds
      )
    )

    somePrintsHaveFailed &&
      toast.error(t("برخی_از_پرینت_ها_انجام_نشد"))

    if (unmount.current) return

    setLoading(false)
  }

  const handleDeleteSelectedPrints = () => {
    setSelectedFailedPrints({})

    const printRequestIds =
      Object.keys(selectedFailedPrints)

    dispatch(
      removeFailedPrints(
        printRequestIds
      )
    )
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  useEffect(() => {
    setLoading(false)
  }, [selectedFailedPrinter])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const disabled =
    loading ||
    Object.keys(selectedFailedPrints).length === 0

  return (
    <div className={classes["footer"]}>
      <Button
        disabled={disabled}
        className={clsx(classes["button"], isLtr && classes["button-ltr"])}
        color="danger"
        onClick={handleDeleteSelectedPrints}
      >
        {t("حذف")}
      </Button>

      <Button
        disabled={disabled}
        loading={loading}
        color="success"
        onClick={handlePrintSelectedPrints}
      >
        {t("پرینت")}
      </Button>
    </div>
  )
}

export default FailedPrintFooter